import loadable from "@loadable/component"
import { FocusScope } from "@react-aria/focus"
import { useHover } from "@react-aria/interactions"
import PropTypes from "prop-types"
import { useContext, Suspense } from "react"
import { connect } from "react-redux"

import { deactivateSubmenu } from "app-store-v2/app/actions"
import { HeaderMenuContext } from "areas/header/jewlr"
import Media from "components/ui/media"
import { retry } from "helpers/application"

import MenuItem from "./menu-item"

const DesktopDropdown = loadable(() => retry(() => import("./dropdown")), {
  ssr: false,
})

const InternalDesktopMenu = ({ empty, leftMenu }) => {
  const { menu } = useContext(HeaderMenuContext)
  const { hoverProps } = useHover({
    onHoverEnd: () => leftMenu(),
  })

  const menuItems = menu && menu.categories
  // const saleItems =
  //   saleMenu && saleMenu.map((link) => ({ ...link, type: "link" }))
  // const items = [...menuItems, ...saleItems]
  const items = menuItems

  return (
    <Media className="w-full" greaterThanOrEqual="large">
      <div className="px-48" {...hoverProps}>
        <nav
          aria-label="Main Navigation"
          className="max-w-1080 mx-auto"
          id="nav-menu"
        >
          <FocusScope>
            <ul className="h-(--desktop-header-height) relative flex list-none flex-nowrap items-center justify-between">
              {!empty &&
                items.map((item, index) => (
                  <MenuItem
                    index={index}
                    item={item}
                    key={`${item.name}-${index}`}
                  />
                ))}
            </ul>
          </FocusScope>
          {typeof window !== "undefined" && (
            <Suspense fallback={<div />}>
              <DesktopDropdown />
            </Suspense>
          )}
        </nav>
      </div>
    </Media>
  )
}

InternalDesktopMenu.propTypes = {
  empty: PropTypes.bool,
  leftMenu: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    saleMenu: state.sale.menu.desktop,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    leftMenu: () => dispatch(deactivateSubmenu()),
  }
}

const DesktopMenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalDesktopMenu)

export default DesktopMenu
